import { ICONS } from "@/utils/constants";
import { useApp } from "../../hooks";
import { Icon } from "./Icon";

interface ActionsProps {
    login: () => void;
    sharePosition: () => void;
    partecipate: () => void;
    beaconScan: () => void;
    openBottomSheet: () => void;
}

export default function Actions({
    login,
    sharePosition,
    partecipate,
    beaconScan,
    openBottomSheet }: ActionsProps) {

    const { roomSession, } = useApp()

    return (
        <div className="fab fab-flower z-0">
            {/* a focusable div with tabIndex is necessary to work on all browsers. role="button" is necessary for accessibility */}
            <div
                tabIndex={0}
                role="button"
                className="btn btn-lg btn-circle btn-success">
                <Icon name="add_2" className="text-2xl leading-none" />
            </div>

            <button
                className="fab-main-action btn btn-circle btn-lg btn-info">
                <Icon name="add_2" className="text-2xl leading-none rotate-45" />
            </button>

            <div className="tooltip tooltip-left relative">
                <button
                    className="btn btn-lg btn-circle btn-secondary"
                    onClick={() => openBottomSheet()}>
                    <Icon name="shelf_auto_hide" className="text-2xl leading-none" />
                </button>
            </div>

            {!roomSession && (
                <>

                    <div className="tooltip tooltip-left">
                        <button
                            className="btn btn-lg btn-circle btn-accent"
                            onClick={() => partecipate()}>
                            <Icon name={ICONS.group} className="text-2xl leading-none" />
                        </button>
                    </div>

                    <div className="tooltip tooltip-left">
                        <button
                            className="btn btn-lg btn-circle btn-success"
                            onClick={() => login()}>
                            <Icon name={ICONS.session} className="text-2xl leading-none" />
                        </button>
                    </div>
                </>
            )}

            {roomSession && (
                <>
                    <div className="tooltip tooltip-left">
                        <button
                            className="btn btn-lg btn-circle btn-accent"
                            onClick={() => beaconScan()}>
                            <Icon name={ICONS.qrCodeScanner} className="text-2xl leading-none" />
                        </button>
                    </div>

                    <div className="tooltip tooltip-left">
                        <button
                            className="btn btn-lg btn-circle btn-primary"
                            onClick={() => sharePosition()}>
                            <Icon name={ICONS.shareWithPeople} className="text-2xl leading-none" />
                        </button>
                    </div>

                </>
            )}

        </div>
    )
}